var map = {
	"./aircrafts.svg": 1034,
	"./antiAir.svg": 5572,
	"./armoredVehicles.svg": 8162,
	"./artillery.svg": 8789,
	"./cisterns.svg": 3306,
	"./copy.svg": 7823,
	"./facebook.svg": 1664,
	"./fondy.svg": 5462,
	"./helicopters.svg": 6855,
	"./icon_chart.svg": 7531,
	"./icon_download.svg": 1511,
	"./icon_heart.svg": 4018,
	"./icon_home.svg": 2006,
	"./instagram.svg": 7484,
	"./logo_CBA_eng.svg": 1262,
	"./logo_CBA_ua.svg": 8801,
	"./mlrs.svg": 8356,
	"./patreon.svg": 996,
	"./personnel.svg": 9355,
	"./personnel_2.svg": 7192,
	"./rotate.svg": 4249,
	"./specialVehicle.svg": 6880,
	"./srmb.svg": 6090,
	"./tanks.svg": 5933,
	"./twitter.svg": 8906,
	"./uav.svg": 1022,
	"./unknown.svg": 9874,
	"./vehicles.svg": 2395,
	"./vessels.svg": 8392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1578;